export default {
    data: [
                {
                    "cityName": "서울",
                    "subCities": [
                        {
                        "name": "전체",
                        "activate": true
                        },
                        {
                        "name": "강남구",
                        "activate": true
                        },
                        {
                        "name": "강동구",
                        "activate": true
                        },
                        {
                        "name": "강북구",
                        "activate": true
                        },
                        {
                        "name": "강서구",
                        "activate": true
                        },
                        {
                        "name": "관악구",
                        "activate": true
                        },
                        {
                        "name": "광진구",
                        "activate": true
                        },
                        {
                        "name": "구로구",
                        "activate": true
                        },
                        {
                        "name": "금천구",
                        "activate": true
                        },
                        {
                        "name": "노원구",
                        "activate": true
                        },
                        {
                        "name": "도봉구",
                        "activate": true
                        },
                        {
                        "name": "동대문구",
                        "activate": true
                        },
                        {
                        "name": "동작구",
                        "activate": true
                        },
                        {
                        "name": "마포구",
                        "activate": true
                        },
                        {
                        "name": "서대문구",
                        "activate": true
                        },
                        {
                        "name": "서초구",
                        "activate": true
                        },
                        {
                        "name": "성동구",
                        "activate": true
                        },
                        {
                        "name": "성북구",
                        "activate": true
                        },
                        {
                        "name": "송파구",
                        "activate": true
                        },
                        {
                        "name": "양천구",
                        "activate": true
                        },
                        {
                        "name": "영등포구",
                        "activate": true
                        },
                        {
                        "name": "용산구",
                        "activate": true
                        },
                        {
                        "name": "은평구",
                        "activate": true
                        },
                        {
                        "name": "종로구",
                        "activate": true
                        },
                        {
                        "name": "중구",
                        "activate": true
                        },
                        {
                        "name": "중랑구",
                        "activate": true
                        }
                    ]
                    },
                    {
                    "cityName": "부산",
                    "subCities": [
                        {     
                        "name": "전체",
                        "activate": true
                        },
                        {
                        "name": "강서구",
                        "activate": true
                        },
                        {
                        "name": "금정구",
                        "activate": true
                        },
                        {
                        "name": "기장군",
                        "activate": true
                        },
                        {
                        "name": "남구",
                        "activate": true
                        },
                        {
                        "name": "동구",
                        "activate": true
                        },
                        {
                        "name": "동래구",
                        "activate": true
                        },
                        {
                        "name": "부산진구",
                        "activate": true
                        },
                        {
                        "name": "북구",
                        "activate": true
                        },
                        {
                        "name": "사상구",
                        "activate": true
                        },
                        {
                        "name": "사하구",
                        "activate": true
                        },
                        {
                        "name": "서구",
                        "activate": true
                        },
                        {
                        "name": "수영구",
                        "activate": true
                        },
                        {
                        "name": "연제구",
                        "activate": true
                        },
                        {
                        "name": "동도구",
                        "activate": true
                        },
                        {
                        "name": "중구",
                        "activate": true
                        },
                        {
                        "name": "해운대구",
                        "activate": true
                        },
                        {
                        "name": "영도구",
                        "activate": true
                        }
                    ]
                    },
                    {
                    "cityName": "대구",
                    "subCities": [
                        {
                        "name": "전체",
                        "activate": true
                        },
                        {
                        "name": "남구",
                        "activate": true
                        },
                        {
                        "name": "달서구",
                        "activate": true
                        },
                        {
                        "name": "달성군",
                        "activate": true
                        },
                        {
                        "name": "동구",
                        "activate": true
                        },
                        {
                        "name": "북구",
                        "activate": true
                        },
                        {
                        "name": "서구",
                        "activate": true
                        },
                        {
                        "name": "수성구",
                        "activate": true
                        },
                        {
                        "name": "중구",
                        "activate": true
                        }
                    ]
                    },
                    {
                    "cityName": "인천",
                    "subCities": [
                        {
                        "name": "전체",
                        "activate": true
                        },
                        {
                        "name": "계양구",
                        "activate": true
                        },
                        {
                        "name": "남동구",
                        "activate": true
                        },
                        {
                        "name": "동구",
                        "activate": true
                        },
                        {
                        "name": "부평구",
                        "activate": true
                        },
                        {
                        "name": "서구",
                        "activate": true
                        },
                        {
                        "name": "연수구",
                        "activate": true
                        },
                        {
                        "name": "옹진군",
                        "activate": true
                        },
                        {
                        "name": "중구",
                        "activate": true
                        },
                         {
                        "name": "강화군",
                        "activate": true
                        },
                        {
                        "name": "미추홀구",
                        "activate": true
                        }
                    ]
                    },
                    {
                    "cityName": "광주",
                    "subCities": [
                        {
                        "name": "전체",
                        "activate": true
                        },
                        {
                        "name": "광산구",
                        "activate": true
                        },
                        {
                        "name": "남구",
                        "activate": true
                        },
                        {
                        "name": "동구",
                        "activate": true
                        },
                        {
                        "name": "북구",
                        "activate": true
                        },
                        {
                        "name": "서구",
                        "activate": true
                        }
                    ]
                    },
                    {
                    "cityName": "대전",
                    "subCities": [
                        {
                        "name": "전체",
                        "activate": true
                        },
                        {
                        "name": "대덕구",
                        "activate": true
                        },
                        {
                        "name": "동구",
                        "activate": true
                        },
                        {
                        "name": "서구",
                        "activate": true
                        },
                        {
                        "name": "유성구",
                        "activate": true
                        },
                        {
                        "name": "중구",
                        "activate": true
                        }
                    ]
                    },
                    {
                    "cityName": "울산",
                    "subCities": [
                        {
                        "name": "전체",
                        "activate": true
                        },
                        {
                        "name": "남구",
                        "activate": true
                        },
                        {
                        "name": "동구",
                        "activate": true
                        },
                        {
                        "name": "북구",
                        "activate": true
                        },
                        {
                        "name": "울주군",
                        "activate": true
                        },
                        {
                        "name": "중구",
                        "activate": true
                        }
                    ]
                    },
                    {
                    "cityName": "경기",
                    "subCities": [
                        {
                        "name": "전체",
                        "activate": true
                        },
                        {
                        "name": "가평군",
                        "activate": true
                        },
                        {
                        "name": "고양시 덕양구",
                        "activate": true
                        },
                        {
                        "name": "고양시 일산동구",
                        "activate": true
                        },

                        {
                        "name": "과천시",
                        "activate": true
                        },
                        {
                        "name": "광명시",
                        "activate": true
                        },
                        {
                        "name": "광주시",
                        "activate": true
                        },
                        {
                        "name": "구리시",
                        "activate": true
                        },
                        {
                        "name": "군포시",
                        "activate": true
                        },
                        {
                        "name": "김포시",
                        "activate": true
                        },
                        {
                        "name": "남양주시",
                        "activate": true
                        },
                        {
                        "name": "동두천시",
                        "activate": true
                        },
                        {
                        "name": "부천시 소사구",
                        "activate": true
                        },
                        {
                        "name": "부천시 오정구",
                        "activate": true
                        },
                        {
                        "name": "부천시 원미구",
                        "activate": true
                        },
                        {
                        "name": "성남시 분당구",
                        "activate": true
                        },
                        {
                        "name": "성남시 수정구",
                        "activate": true
                        },
                        {
                        "name": "성남시 중원구",
                        "activate": true
                        },
                        {
                        "name": "수원시 권선구",
                        "activate": true
                        },
                        {
                        "name": "수원시 영통구",
                        "activate": true
                        },
                        {
                        "name": "수원시 장안구",
                        "activate": true
                        },
                        {
                        "name": "수원시 팔달구",
                        "activate": true
                        },
                        {
                        "name": "시흥시",
                        "activate": true
                        },
                        {
                        "name": "안산시 단원구",
                        "activate": true
                        },
                        {
                        "name": "안산시 상록구",
                        "activate": true
                        },
                        {
                        "name": "안성시",
                        "activate": true
                        },
                        {
                        "name": "안양시 동안구",
                        "activate": true
                        },
                        {
                        "name": "안양시 만안구",
                        "activate": true
                        },
                        
                        {
                        "name": "양평군",
                        "activate": true
                        },
                        {
                        "name": "여주시",
                        "activate": true
                        },
                        {
                        "name": "오산시",
                        "activate": true
                        },
                        {
                        "name": "용인시 기흥구",
                        "activate": true
                        },
                        {
                        "name": "용인시 수지구",
                        "activate": true
                        },
                        {
                        "name": "용인시 처인구",
                        "activate": true
                        },
                        {
                        "name": "의왕시",
                        "activate": true
                        },
                        {
                        "name": "의정부시",
                        "activate": true
                        },
                        
                        {
                        "name": "파주시",
                        "activate": true
                        },
                        {
                        "name": "평택시",
                        "activate": true
                        },
                        {
                        "name": "포천시",
                        "activate": true
                        },
                        {
                        "name": "하남시",
                        "activate": true
                        },
                        {
                        "name": "화성시",
                        "activate": true
                        },
                        {
                        "name": "부천시",
                        "activate": true
                        },
                        {
                        "name": "고양시 일산서구",
                        "activate": true
                        },
                        {
                        "name": "양주시",
                        "activate": true
                        },
                        {
                        "name": "연천군",
                        "activate": true
                        },
                        {
                        "name": "이천시",
                        "activate": true
                        },
                    ]
                    },
                    {
                    "cityName": "충청북도",
                    "subCities": [
                        {
                        "name": "전체",
                        "activate": true
                        },
                        
                        {
                        "name": "보은군",
                        "activate": true
                        },
                        {
                        "name": "영동군",
                        "activate": true
                        },
                        
                        {
                        "name": "음성군",
                        "activate": true
                        },
                        {
                        "name": "제천시",
                        "activate": true
                        },
                        {
                        "name": "증평군",
                        "activate": true
                        },
                        
                        {
                        "name": "청주시 상당구",
                        "activate": true
                        },
                        {
                        "name": "청주시 서원구",
                        "activate": true
                        },
                        {
                        "name": "청주시 청원구",
                        "activate": true
                        },
                        {
                        "name": "청주시 흥덕구",
                        "activate": true
                        },
                        {
                        "name": "충주시",
                        "activate": true
                        },
                        {
                        "name": "괴산군",
                        "activate": true
                        },
                        {
                        "name": "단양군",
                        "activate": true
                        },
                        {
                        "name": "옥천군",
                        "activate": true
                        },
                        {
                        "name": "진천군",
                        "activate": true
                        },
                    ]
                    },
                    {
                    "cityName": "충청남도",
                    "subCities": [
                        {
                        "name": "전체",
                        "activate": true
                        },
                        
                        {
                        "name": "공주시",
                        "activate": true
                        },
                        
                        {
                        "name": "논산시",
                        "activate": true
                        },
                        
                        {
                        "name": "보령시",
                        "activate": true
                        },
                        {
                        "name": "부여군",
                        "activate": true
                        },
                        {
                        "name": "서산시",
                        "activate": true
                        },
                        
                        {
                        "name": "아산시",
                        "activate": true
                        },                        
                        {
                        "name": "천안시 동남구",
                        "activate": true
                        },
                        {
                        "name": "천안시 서북구",
                        "activate": true
                        },                        
                        {
                        "name": "홍성군",
                        "activate": true
                        },
                        {
                        "name": "당진시",
                        "activate": true
                        },
                        {
                        "name": "계룡시",
                        "activate": true
                        },
                        {
                        "name": "금산군",
                        "activate": true
                        },

                        {
                        "name": "서천군",
                        "activate": true
                        },
                        {
                        "name": "예산군",
                        "activate": true
                        },
                        {
                        "name": "청양군",
                        "activate": true
                        },
                        {
                        "name": "태안군",
                        "activate": true
                        },
                    ]
                    },
                    {
                    "cityName": "전라북도",
                    "subCities": [
                        {
                        "name": "전체",
                        "activate": true
                        },
                        
                        {
                        "name": "군산시",
                        "activate": true
                        },
                        {
                        "name": "김제시",
                        "activate": true
                        },
                        {
                        "name": "남원시",
                        "activate": true
                        },
                        {
                        "name": "무주군",
                        "activate": true
                        },
                        
                        {
                        "name": "순창군",
                        "activate": true
                        },
                        {
                        "name": "완주군",
                        "activate": true
                        },
                        {
                        "name": "익산시",
                        "activate": true
                        },
                        {
                        "name": "임실군",
                        "activate": true
                        },
                        
                        {
                        "name": "전주시 덕진구",
                        "activate": true
                        },
                        {
                        "name": "전주시 완산구",
                        "activate": true
                        },
                        {
                        "name": "정읍시",
                        "activate": true
                        },
                        {
                        "name": "진안군",
                        "activate": true
                        },
                        {
                        "name": "고창군",
                        "activate": true
                        },
                        {
                        "name": "부안군",
                        "activate": true
                        },
                        {
                        "name": "장수군",
                        "activate": true
                        },
                    ]
                    },
                    {
                    "cityName": "전라남도",
                    "subCities": [
                        {
                        "name": "전체",
                        "activate": true
                        },
                        {
                        "name": "강진군",
                        "activate": true
                        },
                        {
                        "name": "고흥군",
                        "activate": true
                        },
                        {
                        "name": "곡성군",
                        "activate": true
                        },
                        {
                        "name": "광양시",
                        "activate": true
                        },
                        
                        {
                        "name": "나주시",
                        "activate": true
                        },                        
                        {
                        "name": "목포시",
                        "activate": true
                        },
                        {
                        "name": "무안군",
                        "activate": true
                        },                        
                        {
                        "name": "순천시",
                        "activate": true
                        },                        
                        {
                        "name": "여수시",
                        "activate": true
                        },                        
                        {
                        "name": "영암군",
                        "activate": true
                        },
                        {
                        "name": "완도군",
                        "activate": true
                        },
                        {
                        "name": "장성군",
                        "activate": true
                        },
                        {
                        "name": "장흥군",
                        "activate": true
                        },
                        {
                        "name": "진도군",
                        "activate": true
                        },
                        {
                        "name": "함평군",
                        "activate": true
                        },
                        {
                        "name": "해남군",
                        "activate": true
                        },
                        {
                        "name": "화순군",
                        "activate": true
                        },
                        {
                        "name": "구례군",
                        "activate": true
                        },
                        {
                        "name": "담양군",
                        "activate": true
                        },
                        {
                        "name": "보성군",
                        "activate": true
                        },
                        {
                        "name": "신안군",
                        "activate": true
                        },
                        {
                        "name": "영광군",
                        "activate": true
                        },
                    ]
                    },
                    {
                    "cityName": "경상북도",
                    "subCities": [
                        {
                        "name": "전체",
                        "activate": true
                        },
                        {
                        "name": "경산시",
                        "activate": true
                        },
                        {
                        "name": "경주시",
                        "activate": true
                        },
                        
                        {
                        "name": "구미시",
                        "activate": true
                        },                        
                        {
                        "name": "김천시",
                        "activate": true
                        },
                        {
                        "name": "문경시",
                        "activate": true
                        },
                        {
                        "name": "봉화군",
                        "activate": true
                        },
                        {
                        "name": "상주시",
                        "activate": true
                        },
                        {
                        "name": "성주군",
                        "activate": true
                        },
                        {
                        "name": "안동시",
                        "activate": true
                        },                        
                        {
                        "name": "영양군",
                        "activate": true
                        },
                        {
                        "name": "영주시",
                        "activate": true
                        },
                        {
                        "name": "영천시",
                        "activate": true
                        },                        
                        {
                        "name": "의성군",
                        "activate": true
                        },
                        {
                        "name": "청도군",
                        "activate": true
                        },                        
                        {
                        "name": "포항시 남구",
                        "activate": true
                        },
                        {
                        "name": "포항시 북구",
                        "activate": true
                        },
                        {
                        "name": "고령군",
                        "activate": true
                        },
                        {
                        "name": "군위군",
                        "activate": true
                        },
                        {
                        "name": "영덕군",
                        "activate": true
                        },
                        {
                        "name": "예천군",
                        "activate": true
                        },
                        {
                        "name": "울릉군",
                        "activate": true
                        },
                        {
                        "name": "울진군",
                        "activate": true
                        },
                        {
                        "name": "청송군",
                        "activate": true
                        },
                        {
                        "name": "칠곡군",
                        "activate": true
                        },
                    ]
                    },
                    {
                    "cityName": "경상남도",
                    "subCities": [
                        {
                        "name": "전체",
                        "activate": true
                        },
                        {
                        "name": "거제시",
                        "activate": true
                        },
                        {
                        "name": "거창군",
                        "activate": true
                        },
                        {
                        "name": "고성군",
                        "activate": true
                        },
                        {
                        "name": "김해시",
                        "activate": true
                        },
                        {
                        "name": "남해군",
                        "activate": true
                        },
                        {
                        "name": "밀양시",
                        "activate": true
                        },
                        {
                        "name": "사천시",
                        "activate": true
                        },                        
                        {
                        "name": "양산시",
                        "activate": true
                        },
                        {
                        "name": "의령군",
                        "activate": true
                        },
                        {
                        "name": "진주시",
                        "activate": true
                        },
                        {
                        "name": "창녕군",
                        "activate": true
                        },
                        {
                        "name": "창원시 마산합포구",
                        "activate": true
                        },
                        {
                        "name": "창원시 마산회원구",
                        "activate": true
                        },
                        {
                        "name": "창원시 성산구",
                        "activate": true
                        },
                        {
                        "name": "창원시 의창구",
                        "activate": true
                        },
                        {
                        "name": "창원시 진해구",
                        "activate": true
                        },
                        {
                        "name": "통영시",
                        "activate": true
                        },
                        {
                        "name": "하동군",
                        "activate": true
                        },
                        {
                        "name": "함안군",
                        "activate": true
                        },
                        {
                        "name": "함양군",
                        "activate": true
                        },
                        {
                        "name": "합천군",
                        "activate": true
                        },
                        {
                        "name": "산청군",
                        "activate": true
                        },
                    ]
                    },
                    {
                    "cityName": "제주도",
                    "subCities": [
                        {
                        "name": "전체",
                        "activate": true
                        },
                        {
                        "name": "서귀포시",
                        "activate": true
                        },
                        {
                        "name": "제주시",
                        "activate": true
                        }
                    ]
                    },
                    {
                    "cityName": "강원도",
                    "subCities": [
                        {
                        "name": "전체",
                        "activate": true
                        },
                        {
                        "name": "강릉시",
                        "activate": true
                        },
                        {
                        "name": "고성군",
                        "activate": true
                        },
                        {
                        "name": "동해시",
                        "activate": true
                        },
                        {
                        "name": "삼척시",
                        "activate": true
                        },
                        {
                        "name": "속초시",
                        "activate": true
                        },                        
                        {
                        "name": "원주시",
                        "activate": true
                        },                        
                        {
                        "name": "철원군",
                        "activate": true
                        },
                        {
                        "name": "춘천시",
                        "activate": true
                        },                        
                        {
                        "name": "평창군",
                        "activate": true
                        },
                        {
                        "name": "홍천군",
                        "activate": true
                        },
                        {
                        "name": "화천군",
                        "activate": true
                        },
                        {
                        "name": "횡성군",
                        "activate": true
                        },
                        {
                        "name": "양구군",
                        "activate": true
                        },
                        {
                        "name": "양양군",
                        "activate": true
                        },
                        {
                        "name": "영월군",
                        "activate": true
                        },
                        {
                        "name": "인제군",
                        "activate": true
                        },
                        {
                        "name": "정선군",
                        "activate": true
                        },
                        {
                        "name": "태백시",
                        "activate": true
                        },
                    ]
                    },
                    {
                    "cityName": "세종",
                    "subCities": [
                        {
                        "name": "세종시",
                        "activate": true
                        }
                    ]
                }
            ]
}


// WEBPACK FOOTER //
// ./src/utilities/location.js